import * as React from 'react';
import { connect, useDispatch } from 'react-redux';
import * as microsoftTeams from "@microsoft/teams-js";
import { Label, Stack, TextField } from '@fluentui/react';
import { useId } from '@uifabric/react-hooks';
import { BrowserStorageKey } from '../../constant/storage';
import { useHistory } from 'react-router';
import { Dropdown } from '@fluentui/react-northstar';
import { addToMeeting, saveMeeting } from '../../store/Meeting/actions';
import { getBookmarks } from '../../store/Bookmark/actions';

import styles from './index.module.scss';
import { useTypedSelector } from '../../store';
import { ApplicationState } from '../../store/appThunkAction';
import hubService from '../../api/services/hub';

const Configure = () => {

    const dispatch = useDispatch();
    const history = useHistory();
    const {
        bookmarks,
        loading
    } = useTypedSelector((state: ApplicationState) => state.bookmark);

    const {
        currentMeeting,
        teamEvent,
        theme
    } = useTypedSelector((state: ApplicationState) => state.meeting);



    const [selectedItems, setSelectedItems] = React.useState([] as number[]);
    const [isBookmarkOpen, setIsBookmarkOpen] = React.useState(false);
    const [isCrmOpen, setIsCrmOpen] = React.useState(false);
    const textFieldId = useId('hubTabName');
    const crmFieldId = useId('crmField');
    const bookmarkFieldId = useId('bookmarkFieldId');
    const saveChanges = (saveEvent: microsoftTeams.settings.SaveEvent) => {
        const hostName = window.location.host;
        const url = `https://${hostName}`;
        microsoftTeams.settings.setSettings({
            websiteUrl: url,
            contentUrl: url,
            entityId: "preMeetingTab",
            suggestedDisplayName: 'Bigtincan'
        });
        saveEvent.notifySuccess();
    };
    const saveSetting = () => {
        microsoftTeams.settings.registerOnSaveHandler((saveEvent) => {
            if (selectedItems && currentMeeting) {
                selectedItems.forEach((selectedItem) => {
                    const item = bookmarks.find(c => c.id === selectedItem);
                    if (item && item.setData) {
                        item.setData.forEach((row) => {
                            if (row && row.type === 'file') {
                                dispatch(addToMeeting(currentMeeting.id, row.id, row.permId, ''));
                            }
                        });
                    }
                });
                saveChanges(saveEvent);

            } else {
                saveChanges(saveEvent);
            }
        });
    };
    React.useEffect(() => {
        microsoftTeams.initialize(() => {
            hubService.getLoggedInUser().then((profile) => {
                microsoftTeams.getContext((context) => {
                    dispatch(getBookmarks());
                        if (context.chatId) {//replaced meetingId with chatId
                            const userProfile: any = profile;
                            const userId = userProfile.value.id;
                            const userEmail = userProfile.value.email;
                            const data = {
                                meetingId: context.chatId,
                                eventId: (teamEvent != null)? teamEvent.id : "",
                                description: '',
                                name: '',
                                hubUserId: userId,
                                hubEmail: userEmail,
                                userEmail: context.loginHint,
                                contents: [],
                                attendee: [{
                                    email: context.loginHint,
                                    name: context.userPrincipalName
                                }]
                            };
                            dispatch(saveMeeting(data));
                        }
                    
                });
            });
        });
    }, []);

    React.useEffect(() => {
        microsoftTeams.settings.setValidityState(true);
        saveSetting();
    }, [selectedItems, currentMeeting]);

    React.useEffect(() => {
        const token = localStorage.getItem(BrowserStorageKey.ACCESS_TOKEN);
        if (!token) {
            history.push('/login');
        }

    }, []);


    const inputItems: any = [];
    let bookmarkListStyle = {};
    if (isBookmarkOpen) {
        bookmarkListStyle = {
            ...bookmarkListStyle,
            height: '150px',
            cursor: 'pointer',
        }
    }

    let crmListStyle = {};
    if (isCrmOpen) {
        crmListStyle = {
            ...crmListStyle,
            height: '150px',
            cursor: 'pointer',
        }
    };

    return (
        <Stack className={[styles.root, styles["ms-teams-theme-" + theme]].join(' ')}>
            <Label htmlFor={textFieldId}>Tab Name</Label>
            <TextField disabled id={textFieldId} value={'Bigtincan'} className={styles.tabName} />
            <Label className={styles.label} htmlFor={crmFieldId}>Select Bookmarks (Optional)</Label>
            <Dropdown
                fluid
                search
                multiple
                onChange={(_e, value) => {
                    setSelectedItems((value.value as any[]).map((row: any) => row.id as number));
                }}
                items={(bookmarks || []).map((item) => {
                    return {
                        header: item.name,
                        id: item.id,
                        styles: {
                            padding: '10px'
                        }
                    };
                })}
                placeholder="Start typing a name"
                noResultsMessage="We couldn't find any matches."
            />
        </Stack>
    )
};

export default connect()(Configure);
